import { DateTime } from 'luxon';
import moment from 'moment-timezone'; // TODO: Remove Moment with Tech Task TEC-138

export var DATE_FORMATS = {
  shortWithTime: "LL/dd/y 'at' h:mm a",
  longWithTime: "ccc, MMM dd y 'at' h:mma",
  short: 'LL/dd/y',
  long: 'ccc, MMM d y',
  longCommaYear: 'ccc, MMM d, y',
  longWithoutYear: 'ccc, MMM d',
  year: 'y',
  monthAndYear: 'LLLL y',
  dateInputMask: 'LL/dd/y',
  time: 'h:mma',
  time24: 'HH:mm',
  shortDayOfWeek: 'ccc',
  iso8601: 'y-LL-dd',
  timeZoneAbbreviated: 'ZZZZ'
};

var getTimeZoneAbbreviation = function getTimeZoneAbbreviation(date, timeZone) {
  return date.setZone(timeZone || 'local').toFormat(DATE_FORMATS.timeZoneAbbreviated);
};

var getDateObject = function getDateObject(date) {
  if (DateTime.isDateTime(date)) {
    return date;
  }

  if (typeof date === 'string') {
    return DateTime.fromISO(moment(date).toISOString());
  }

  return DateTime.fromISO(date.toISOString());
};

export function formatDate(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'shortWithTime' : _ref$format,
      timeZone = _ref.timeZone,
      showTimeZone = _ref.showTimeZone;

  var parsedDate = getDateObject(date).setZone(timeZone || 'local');
  var formattedDate = parsedDate.toFormat(DATE_FORMATS[format]); // format date

  if (DATE_FORMATS[format] === DATE_FORMATS.timeZoneAbbreviated) {
    return getTimeZoneAbbreviation(parsedDate, timeZone);
  }

  return showTimeZone ? "".concat(formattedDate, " (").concat(getTimeZoneAbbreviation(parsedDate, timeZone), ")") : formattedDate;
}